import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './homePage';
import SignUpPage from './SignUpPage';
import Footer from './components/footer';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import DoNotSell from './DoNotSell';
import Dashboard from './Dashboard';
import Checkout from './Checkout';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />

          {/** This catches /signup and ANY nested path (e.g. /signup/verify-email-address) */}
          <Route path="/signup/*" element={<SignUpPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/do-not-sell" element={<DoNotSell />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
